export default {
  common: {
    TEMPLATE: {
      DATE: 'Date',
      DATE_TIME: 'Date Time',
      DATE_ONLY_RANGE: 'Date Only Range',
      DATE_AND_TIME: 'Date and Time',
      DATES: 'Dates',
      CATEGORY_MANDATORY: 'Category is a mandatory field. Please fill it in before saving.',
      CATEGORY_TYPE_MANDATORY: 'Category Type is a mandatory field. Please select a value before saving.',
    },
    general: {
      ADD: 'Add',
      START: 'Start',
      EDIT: 'Edit',
      DELETE: 'Delete',
      CONFIRM: 'Confirm',
      SUBMIT: 'Submit',
      SUMMARY: 'Summary',
      VIEW: 'View',
      YES: 'Yes',
      NO: 'No',
      Home: 'Home',
      ALL: 'All',
      ACTIVE: 'Active',
      ACTIVE_ONLY: 'Active Only',
      INACTIVE_ONLY: 'Inactive Only',
      SHOW: 'Show',
      HIDE: 'Hide',
      CLOSE: 'Close',
      OK: 'Ok',
      SAVE: 'Save',
      CANCEL: 'Cancel',
      SAVE_AND_REPUBLISH: 'Save and Republish',
      SAVED_SUCCESSFULLY: 'Saved Successfully',
      UPDATED_SUCCESSFULLY: 'Updated Successfully',
      START_TYPE_PLACEHOLDER: 'Start typing to Select...',
      SELECT_PLACEHOLDER: 'Select...',
      SELECT_MONTH: 'Select Month',
      SELECT_YEAR: 'Select Year',
      SELECT_WEEK: 'Select Week',
      NO_ITEMS: 'No items',
      LEARN_MORE: 'Learn\u00a0More',
    },
    PUBLIC_HEADER: {
      HOTEL: {
        HEADING: 'Hotel',
        FILTER: {
          HEADING: 'Filter',
          STANDARD: 'Standard',
          NEW: 'New',
          STANDARD_SCORE_TYPE: 'Standard Score Type',
        },
      },
    },
    ACTION_PLAN: {
      VIEW: {
        TITLE: 'View Action Plan',
      },
      EDIT: {
        TITLE: 'Edit Action Plan',
      },
      TYPE: {
        TRAINING: 'Training',
        E_LEARNING: 'E-Learning',
        HIRING: 'Hiring',
        PURCHASING: 'Purchasing',
        UPDATING_SOP: 'Updating SOP',
        OTHER: 'Other',
      },
      STATUS: {
        AWAITING_APPROVAL: 'Awaiting Approval',
        REJECTED: 'Rejected',
      },
    },
    assessments: {
      'All': 'All',
      'LQA': 'LQA',
      'Reservation': 'Reservation',
      'Event': 'Event',
      'MeetingAndEvents': 'Meeting & Events',
      'Guest Services': 'Guest Services',
      'Spa Reservation': 'Spa Reservation',
      'FoodAndBeverage': 'Food & Beverage',
      'Hotels': 'Hotels',
      'Auditors': 'Auditors',
      'Status': 'Status',
      'Invoice Status': 'Invoice Status',
      'Last Day of Stay Cutoff': 'Last Day of Stay Cutoff',
      'Type': 'Type',
      'Test Assessment': 'Test Assessment',
      'TestAssessment': 'Test Assessment',
      'HoldAssessment': 'Hold Assessment',
      'Action required': 'Action required',
      'Requiring action': 'Requiring action',
      'Sort by Feedback Date': 'Sort by Feedback Date',
      'Please select...': 'Please select...',
      'Start typing to select...': 'Start typing to select...',
      'Assessments': 'Assessments',
    },
    ASSESSMENT: {
      STATUS: {
        CREATED: '1 Created',
        CONSULTANT_DEMO: '2 Consultant Demo',
        AWAITING_PROOF: '3 Awaiting Proof',
        PROOFING: '4 Proofing',
        READY_TO_PUBLISH: '5 Ready to Publish',
        AWAITING_FEEDBACK: '6 Awaiting Feedback',
        LIVE: '7 Live',
      },
      ERRORS: {
        NO_DATA: 'No data to display',
        DATA_NOT_FOUND: 'Data not found',
        NO_ASSESSMENTS_RETURNED_FOR_THIS_DATE_RANGE: 'No assessments returned for this date range',
        HOTEL: 'Please select a hotel from the list',
        STANDARDS: {
          MESSAGES: {
            ENTER_VALID_AMOUNT: 'Please enter a valid amount',
          },
        },
        CONTRACT_TEMPLATE_NOT_FOUND: 'Contract template not found',
        PROOFREADER_NOTES: {
          MESSAGES: {
            NOTE_SHOULD_NOT_BE_EMPTY: 'Note should not be empty.',
          },
        },
        STAR_EMPLOYEE: {
          TOAST_LEAD: 'Unable to save the assessment.',
          TOAST_INTRO: 'Please clear or complete the Star Employee information with:',
          TOAST_FIELD: '- {field}',
          TOAST_CLOSE: 'to save the assessment.',
          REQUIRED: '* Required',
          FIELDS: {
            NAME: 'Name',
            SECTION: 'Section',
            DATE: 'Date',
          },
        },
      },
      CLICK_DEPARTMENT_SEE_DETAILS: 'Click on a department to see detail',
      ALERT_MESSAGES: {
        CANCEL_UNSAVED_CHANGES: 'Are you sure you want to leave this tab? You have unsaved changes.',
      },
      STATUS_CHANGE: {
        STAY_IN_FUTURE: "Whoops, this stay is scheduled to happen in the future, so you can't change the status yet",
        EXPENSES_INCOMPLETE: 'The assessment status cannot be updated until the Expenses tab is completed.',
      },
      EXPENSES_INVOICE_ROWS: {
        READY_TO_INVOICE: 'Ready to Invoice',
        INVOICE_IN_PROCESS: 'Invoice in process',
        INVOICED_COMPLETED: 'Invoicing completed',
        INVOICE_SENT: 'Invoice sent',
      },
    },
    SELF_ASSESSMENT: {
      LIST: {
        TABLE_HEADERS: {
          TYPE: 'Type',
          DATE_ASSIGNED: 'Date Assigned',
          NOTES: 'Notes',
          ASSIGNED_TO: 'Assigned To',
          ASSIGNED_BY: 'Assigned By',
          DUE_DATE: 'Due Date',
          SCORE: 'Score',
          ACTIONS: 'Actions',
        },
      },
      TRENDS: {
        TITLE: 'Self Assessment Trends',
        EXPORT_TO_CSV: 'Export to CSV',
        NO_DATA: 'NO DATA TO DISPLAY',
        FILTER: {
          ASSIGNED_BY: 'Assigned By',
          ASSIGNED_TO: 'Assigned To',
          CATEGORY: 'Category',
          DATE_RANGE: 'Date Range',
          DISPLAY_FILTER: 'Display Filter',
          STANDARD: 'Standard',
          BREAKDOWN: 'Breakdown',
          GROUP_BY: 'Group By',
        },
      },
      SUMMARY: {
        COMPLETED: 'Completed',
        TITLE: 'Self Assessment Summary',
        DISPLAY_FILTER: 'Display filter',
        BENCHMARK_OVERALL: 'Benchmark Overall',
        GROUP_COMMENTARY: 'Group Commentary',
        FILTER: {
          TAGGED: 'Tagged',
          DATE_RANGE: 'Date Range',
          STATUS: 'Status',
          CATEGORY: 'Category',
          SUB_DEPARTMENT: 'Sub Department',
          DEPARTMENT: 'Department',
          OWNER: 'Owner',
          CREATOR: 'Creator',
          ASSIGNEE: 'Assignee',
          OUTLET: 'Outlet',
          STANDARD: 'Standard',
          VIEW: 'View',
          ROOM_NUMBER: 'Room Number',
          NO_ROOM_NUMBERS_AVAILABLE: 'No Room Numbers Available',
          NO_OUTLETS_AVAILABLE: 'No Outlets Available',
          PERFORMANCE_CLASSIFICATION: 'Performance Classification',
        },
        REPORT: {
          BENCHMARK_SCORE: 'Benchmark Score',
          DETAILS: 'Details',
          SCORE: 'Score',
          EMOTIONAL_RATING: 'EI Guest Connection',
        },
      },
      DETAILS: {
        TITLE: {
          VIEW: 'View Self Assessment',
          EDIT: 'Edit Self Assessment',
        },
        TOASTS: {
          UPDATED: 'Self Assessment updated',
          SUBMITTED: 'Self Assessment submitted',
        },
        BUTTONS: {
          DOWNLOAD_ASSESSMENT: 'Download Assessment',
          BEGIN_ASSESSMENT_BEFORE_DOWNLOADING: 'Please begin Assessment Before Downloading',
          DOWNLOAD_BLANK_SELF_ASSESSMENT: 'Download blank self assessment',
          CANCEL_CHANGES: 'Cancel Changes',
          SUBMIT_SELF_ASSESSMENT: 'Submit self-assessment',
        },
        TOOLTIPS: {
          SUBMISSION_DISABLED_BODY_INTRO: 'The following assignees haven\'t completed their departments yet:',
          SUBMISSION_DISABLED_BODY_FOOTER: 'All departments must be submitted via myLQA app before this self-assessment can be submitted.',
          SUBMIT_CONFIRMATION: 'Are you sure you want to submit this Self Assessment?',
          SUBMISSION_DISABLED_TITLE: 'Submission is disabled',
          SUBMISSION_DISABLED_BODY: "The following assignees haven't completed their departments yet: {{assigneeNames}}",
          PENDING_CHILD_ASSESSMENTS: 'You can only submit this Self Assessment when the following users finish theirs:',
          SUBMITTED: 'This Self Assessment has already been submitted.',
          UNGRADED_STANDARDS: 'You have not fully graded the Self Assessment. All ungraded standards will be marked as non-applicable.',
          ONLY_CREATOR_OR_ADMINS_CAN_EDIT: 'Only the creator or admins can edit a submitted Self Assessment.',
          ONLY_CREATOR_OR_ADMINS_CAN_SUBMIT: 'Only the creator or admins can submit a Self Assessment.',
        },
      },
    },
    MY_AUDIT: {
      LIST: {
        TITLE: 'myAudit Overview',
        NO_DATA: 'NO DATA TO DISPLAY',
      },
      CHECKLIST: {
        TITLE: 'myAudit Checklists',
        BUTTON_ADD_NEW_CHECKLIST: 'Add new checklist',
      },
      VIEW: {
        TITLE: 'myAudits',
        SELECT_SECTION: 'Please select section',
        OUTLET_NAME: 'Outlet name',
        DATE_AND_TIME: 'Date and Time',
        MEAL_PERIOD: 'Meal Period',
        DATE: 'Date',
        ROOM_NUMBER: 'Room Number',
        COMMENTS: 'Comments',
        TAGGED: 'Tagged',
      },
      OVERVIEW: {
        BUTTON: {
          EXPORT_TO_EXCEL: 'Export to excel',
        },
      },
    },
    POST_ASSESSMENT_ROADMAP: {
      TITLE: 'Post Assessment Roadmap',
      OVERVIEW: {
        NO_ACCESS_TO_CONTENT: 'You don’t have access to this content.',
        GO_TO_ASSESSMENT: 'Go to Assessment Summary',
      },
      BREADCRUMBS: {
        ASSESSMENT: 'Benchmark overall',
      },
      CREATE: {
        TITLE: 'Create post assessment roadmap',
        SUCCESS: 'Post Assessment Roadmap created successfully',
        ERROR: 'Failed to Create Post Assessment Roadmap',
      },
      COMPLETE: {
        TITLE: 'Complete post assessment roadmap',
        ALERT:
          'Your post-assessment roadmap is in progress but not yet submitted. Complete and submit it to finalize your action plan.',
      },
      NO_ASSESSMENT_FOR_THIS_DEPARTMENT: 'No Assessment for this Department',
      DEPARTMENT_ROADMAP: {
        DESCRIPTION: "Add all required actions. Once completed, mark the department as 'Ready for Review'.",
      },
      SUBMIT: {
        SUBMIT_POST_ASSESSMENT_ROADMAP: 'Submit Post Assessment Roadmap',
        CONFIRM_SUBMIT:
          'Are you sure you want to submit Post Assessment Roadmap? After submission you will not be able to make any changes.',
      },
      EMOTIONAL_SUMMARY: {
        TITLE: 'Emotional Summary',
        POSITIVES: 'Positives',
        NEGATIVES: 'Negatives',
      },
      BUTTON: {
        EDIT: 'Edit',
        SUBMIT_POST_ASSESSMENT_ROADMAP: 'Submit Post Assessment Roadmap',
        DOWNLOAD_ROADMAP: 'Download Roadmap',
        DOWNLOAD_PDF: 'PDF',
        DOWNLOAD_EXCEL: 'Excel',
        DOWNLOAD_ERROR_GENERIC: 'There was an error downloading this roadmap. Please try again later.',
        DELETE: 'Delete',
      },
      DELETE: {
        TITLE: 'Delete Post-Assessment Roadmap',
        DESCRIPTION: 'This action will permanently delete the post-assessment roadmap and',
        CANNOT_BE_UNDONE: 'cannot be undone!',
        INSTRUCTION: 'To enable deletion, type "Delete" in the field below.',
        PLACEHOLDER: "Type 'Delete' to confirm",
        BUTTON: {
          DELETE: 'Delete Roadmap',
          CLOSE: 'Close',
        },
        SUCCESS: 'Post Assessment Roadmap deleted successfully',
        ERROR: 'Failed to Delete Post Assessment Roadmap',
        CANNOT_DELETE_SUBMITTED: 'Cannot delete a submitted Post-Assessment Roadmap',
      },
      STATUS: {
        NOT_STARTED: 'Not Started',
        IN_PROGRESS: 'In Progress',
        READY_FOR_REVIEW: 'Ready for Review',
      },
      TABLE: {
        COLUMN: {
          CURRENT_ASSESSMENT_SCORE: 'Current Assessment Score',
          PREVIOUS_ASSESSMENT_SCORE: 'Previous Assessment Score',
          STATUS: 'Status',
          NUMBER_ACTION_PLANS: 'Number of Action Plans',
          ACTIONS: 'Actions',
          PROGRESS_BAR: {
            EXPLAINING_PROGRESS_BAR:
              'This column displays the action plans progress for each department. You can click the progress bar to navigate to the department`s actions.',
          },
        },
      },
      SUB_DEPARTMENT: {
        TITLE: 'Sub Department',
        DESCRIPTION: "Add all required actions. Once completed, mark the sub department as 'Ready for Review'.",
        SCORE: {
          PREVIOUS_SCORE: 'Previous Assessment Score',
          CURRENT_SCORE: 'Current Assessment Score',
        },
        SAVE_AND_CLOSE_CONFIRMATION_MODAL: {
          CONFIRMATION_TITLE: 'Department Information Saved!',
          CONFIRMATION_DESCRIPTION:
            'Click Close to go back to the Post Assessment Roadmap overview page, or Cancel to remain on the current page.',
        },
        RECOMMENDATIONS: 'Recommendations',
        STRATEGY: 'Strategy',
        ACTION_PLAN: {
          TITLE: 'Action Plans',
          ADD_ACTION_PLAN: 'Add Action Plan',
          STANDARDS: 'Standards',
          ACTIONS: 'Actions',
          MEASUREMENT: 'Measurement',
          ACTION_PLAN_TYPE: 'Action Plan Type',
          ACTION_PLAN_MEASUREMENT: 'Action Plan Measurement',
          ASSIGNEE: 'Assignee',
          DESCRIPTION: 'Description',
          DUE_DATE: 'Due Date',
          UPLOAD_ATTACHMENT: 'Upload Attachment',
          CANCEL: 'Cancel',
          TITLE_FIELD: 'Title',
          NO_ACTION_PLANS: 'No Action Plan Added',
          GET_STARTED: 'Get started by adding your first Action Plan',
          DELETE: {
            TITLE: 'Delete Action Plan',
            DESCRIPTION: 'Are you sure you want to delete this action plan?',
          },
          CANCEL_MODAL: {
            TITLE: 'Are you sure?',
            DESCRIPTION: 'You added information to the action plan. If you cancel now, the information will be lost!',
          },
        },
      },
    },
    SUBSCRIPTION: {
      SUMMARY: {
        TITLE: 'myLqa Subscription Summary',
        SUBSCRIPTION_PLAN: 'Subscription Plan',
        STATUS: 'Status',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        UPGRADE_SUBSCRIPTION: 'Upgrade Subscription',
        DOWNGRADE_SUBSCRIPTION: 'Downgrade Subscription',
        FILTERS: {
          HOTELS: 'Hotels',
          SUBSCRIPTION_TYPE: {
            TITLE: 'Subscription Type',
            PAID: 'Paid',
            TRIAL: 'Trial',
            PILOT: 'Pilot',
          },
        },
      },
      CREATE: {
        INCLUDED: 'Included',
        GET_STARTED: 'Get started',
      },
      CHANGE_PLAN: 'Change plan',
      SELECT_PLAN: 'Select this plan',
      DOWNGRADE_ERROR: 'You will be able to downgrade at the end of your contract, which is on',
    },
    EMOTIONAL_INTELLIGENCE: {
      EI_GUEST_CONNECTION: 'EI Guest Connection',
      EXPLAINING_EI_GUEST_CONNECTION:
        'The EI Guest Connection is rated independently of the LQA standards (including the EI Behavioral standards) and reflects the emotional satisfaction of the guest during their interactions.',
      INFO_EI_GUEST_SCORES:
        'Please click on the individual EI Guest Connection Scores to see further details about your hotels that contribute to the score in the selected line.',
    },
    CONTRACTING: {
      SELECT_HOTELS: 'Select Hotels',
      NEW_AGREEMENT: 'New Agreement',
      PARTNER: 'Partner',
      PARTNER_AIRFARE_PAID_BY: 'Partner Airfare Paid By',
      RE_INSPECTION: 'Re Inspection',
      NEW_INSPECTION: 'New Inspection',
      ASSESSMENT: 'Assessment',
      TRAINING: 'Training',
      ASSESSMENT_TRAINING: 'Assessment & Training',
      ADDITIONAL_ASSESSMENTS: 'Additional Assessments',
      RESERVATION_CALLS: 'Reservation Calls',
      SPA_RESERVATIONS: 'Spa Reservations',
      GUEST_SERVICES: 'Guest Services',
      MEETINGS_EVENTS: 'Meetings & Events',
      MESSAGE: {
        SELECT_FILE_UPLOAD: 'Please select a file to upload.',
        CONTRACT_NOT_FOUND: 'Contract not found.',
        FILE_UPLOAD_SUCCESSFUL: 'File uploaded successfully.',
        FAILED_FETCHING_SIGNED_URL: 'Failed to get signed URL.',
        GENERAL_UPLOAD_ERROR: 'An error occurred during the upload.',
        STATUS_ERROR: 'Completed Contract cannot be set to other status.',
        CURRENCY_REQUIRED: 'Currency is required.',
      },
    },
    ASSESSMENT_MANAGEMENT: {
      ERRORS: {
        MAXIMUM_ASSESSMENT_LIMIT_PER_CONTRACT: 'Maximum limit is 100 assessments per contract',
        MINIMUM_ASSESSMENT_REQUIRED_FOR_CONTRACT: 'At least one assessment required to mark as complete',
        NO_CONTRACT_TO_SAVE: 'No contract to save',
        INCOMPLETE_DATE: 'Please select a month or time frame before saving.',
      },
      SUCCESS: {
        BULK_ACTION_SUCCESSFUL: 'Bulk action successful',
      },
      FILTER: {
        DISPLAY_FILTER: 'Display Filter',
        HOTEL_SCHEDULING: 'Hotel Scheduling',
      },
      PROSPECT_AND_CONTRACT_INFORMATION: 'Prospect and Contract Information',
    },
    CLIENT_USER: {
      MYLQA_ACCESS_NOT_REMOVABLE: 'Brand level users and Regional users can’t have their app access myLQA removed.',
      OPTION: 'Option',
      PHONE_NUMBER_CONSENT:
        'By registering with a phone number you agree to receive automated transactional messages from Leading Quality Assurance (LQA). Text and data rates may apply. Reply STOP to unsubscribe.',
    },
    CLIENT: {
      BRAND_ADD_INFORMATION:
        'Please create the brand first on the brands page and then you will be able to create and connect a client to them',
      ASSOCIATED_BRANDS: 'Associated Brands',
      UPDATE_STATUS_MESSAGE: 'Status updated',
      CONFIRM_STATUS_CHANGE_TITLE: 'Are you sure you want to change the status of this client?',
    },
    BRAND: {
      DASHBOARD: {
        COMPETING_BRANDS: 'Competing Brands',
      },
      EDIT_BRAND: {
        TITLE: 'Edit Brand',
        DEFAULT_SCORE_TYPE: 'Default Custom Score',
        TEMPLATE: 'Template',
        TEMPLATE_SELF_ASSESSMENT: 'Template (Self Assessment)',
        SECTOR: 'Sector',
        WEBSITE: 'Website',
        DISPLAY_NAME: 'Display Name',
        PREFIX: 'Prefix',
        ALLOW_EXCEL: 'Allow Excel',
        ADJUST_ASSESSMENT: 'Adjust Assessment',
        OPTIONS: 'Options',
        NAME: 'Name',
        BLOCK_OUT_60_DAY: 'Block Out 60-Day Restriction',
        BLOCK_OUT_ALL: 'Block Out Restriction (All)',
        INFORMATION: 'Brand Information',
        WARNING_TEMPLATE_MESSAGE:
          'Since the template is not selected, selected template will be cleared and brand will have no default template.',
        NO_TEMPLATE_SELECTED: 'No template selected',
      },
      MISSED_STANDARDS: {
        COMMENTS: 'Comments',
        STANDARD_COMMENT_DEEP_DIVE_INFORMATION: 'Standard Comment Deep Dive information',
        DEEP_DIVE_LOAD_ERROR: 'Unable to load standard comment deep dive. Please try again.',
      },
      TRENDS: {
        BRAND_COLUMN_HEADER: {
          BRAND: 'Brand',
          HOTELS: 'Hotels',
          BENCHMARK: 'Benchmark',
          ALL_BRANDS_DIFFERENCE: 'All Brand(s) Difference',
          COMP_DIFFERENCE: 'Comp Difference',
        },
        LEGEND_DESCRIPTION: {
          DESCRIPTION: 'Your score compared to the scores within your brand and competitor set.',
          ABOVE_AVG_RANGE: 'Above avg. range',
          BELOW_AVG_RANGE: 'Below avg. range',
          WITHIN_AVG_RANGE: 'Within avg. range (2pts)',
          NO_COMPARISON_DATA_AVAILABLE: 'No comparison data available',
        },
      },

      DEEP_DIVE: {
        DETAILED_VIEW_OF_THE_HOTEL: 'Detailed view of the hotels included in this score.',
        DOWNLOAD_REPORT: 'Download report',
        GENERATE_AI_SUMMARY: 'Generate AI summary',
        GENERATING_AI_SUMMARY: 'Generating AI summary...',
        AI_SUMMARY: 'AI-generated summary available',
        AI_SUMMARY_ERROR: 'Failed to generate AI summary. Please try again.',
        COLLAPSE: 'Collapse',
        EXPAND: 'Expand',
        SUMMARY_OF_X_FOR_Y_HOTELS: 'Summary of {departmentName} for {scoringTypeLabel} hotels',
        SUMMARY_FOR_X_HOTELS: 'Summary for {scoringTypeLabel} hotels',
        AI_SUMMARY_HELPFUL: 'Helpful',
        AI_SUMMARY_NOT_HELPFUL: 'Not helpful',
        AI_SUMMARY_HELPFUL_DESCRIPTION: 'AI-generated answers may be inaccurate. Your feedback matters.',
        MORE_DETAILS: 'More details',
        LESS_DETAILS: 'Less details',
        EXPANDABLE_SUMMARY_DETAILS_REGION: 'Additional AI summary details',
        TRY_AGAIN: 'Try again',
        AI_SUMMARY_CONFIRM_TITLE: 'Before you start',
        AI_SUMMARY_CONFIRM_DESCRIPTION:
          'This summary is generated using AI and is based on experimental technology. Responses may occasionally be inaccurate or incomplete. Please review any AI-generated content before acting on it.',
        AI_SUMMARY_CONFIRM_CONTINUE: 'Got it, continue',
        VISIT_NUMBER: 'Visit {{number}}',
      },
    },
    SPOTTED_REPORT: {
      TITLE: 'Spotted Report',
    },
    ERRORS: {
      NO_DATA_FOUND: 'No data found',
      SOMETHING_WENT_WRONG: 'Something went wrong',
      FAILED_TO_DOWNLOAD_FILE: 'Failed to download file.',
      SCREEN_SIZE_TOO_SMALL: 'Screen size too small',
      THIS_PAGE_REQUIRES_A_BIGGER_SCREEN:
        'This page requires a bigger screen to be used. Please switch to desktop browser.',
    },
    UPFRONT_TRAINING: {
      TRAINING_FEEDBACK: {
        PLEASE_FILL_CONTACT_DETAILS_FOR_EVERY_ROW: 'Please fill in contact details for every row.',
      },
    },
    EMOTIONAL_SUMMARY: {
      RESERVATIONS: {
        PARAGRAPH1:
          'Was the call answered straight away, or did you have to wait a long time? Was the greeting professional or casual? Was it friendly, creating a positive start to the conversation? Did the employee sound upbeat and cheerful? (SET THE SCENE)',
        PARAGRAPH2:
          'Did the employee use/not use your name? How was it used and how did that make you feel? Was the interaction personalised? If yes, how and to what degree? Did the employee display empathy, patience or any understanding? Did they respond to humour? Were they friendly? Was their communication style clear and did they sound interested or show curiosity? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Did the employee proactively try and understand your needs and provide suitable suggestions? Was storytelling used, and if yes, any particular details that built anticipation/excitement? Perhaps relevant activities or services were thoughtfully suggested? Were any requests met or adapted to? Any moments to make you feel special, such as arranging a birthday surprise for your guest? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, memorable touchpoints)',
        PARAGRAPH4:
          'Did the employee wish you a genuine farewell? Perhaps they used your name or thanked you for your booking/said they were looking forward to welcoming you? (FAREWELL) Summarise how you felt overall, despite any oversights. Did the conversation create a sense of excitement for your upcoming stay? Perhaps you were left with a negative/positive first impression ahead of your stay? (SUMMARY)',
      },
      CHECK_IN: {
        PARAGRAPH1:
          'Were you welcomed straight away or did you wait in a queue unacknowledged? Were the employees well-groomed which create a professional/sleek/elegant first impression? Was there anything that created a sense of place/arrival such as a welcome drink, ritual, music or decor? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Was the interaction personalised, and if so how and to what degree? Did the employee display empathy, patience or any understanding? Were they friendly? Was their communication style clear and did they use good eye contact and come across as calm or confident? Maybe they asked you about the purpose of your stay? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Was the check-in seamless to provide a stress free experience after a long flight? Did it fully anticipate your needs e.g. an informative orientation to make you feel at home, clear explanation of inclusions and all your booking details? Were any requests met/adapted to? Any special touches, such as offering to book the spa/dinner on your behalf? Was service proactive vs reactive? Were you impressed or disappointed about anything? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, memorable touchpoints).',
        PARAGRAPH4:
          'Did the employee wish you a genuine farewell or pleasant stay as you left the desk? Did they use your name in the farewell? Perhaps they introduced themselves or invited you to contact reception for any further assistance, or introduced you by name to the porter for a seamless handover? (FAREWELL) Summarise how you felt overall, despite any oversights. Perhaps you were left with a negative/positive first impression? Did the arrival experience leave you feeling worried about/looking forward to/excited about the rest of your stay? (SUMMARY)',
      },
      CHECK_OUT: {
        PARAGRAPH1:
          'Did someone offer assistance straight away, or did you join a queue? Did the employee use positive body language as you approached the desk to make you feel welcome? Perhaps the employee was someone you had met already and they recognised you? Or perhaps employees appeared distracted and made little eye contact/were talking to their colleagues. (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the employee ask you about your stay or engage you in conversation? Was your name used or was empathy displayed? Was the conversation engaging or personalised and if so – how and to what degree? Any special touches, such as a personalised farewell gift? Was an invitation to return extended at this point, and if so, what was said and how did it make you feel? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Did check out feel seamless or were there any misunderstandings or errors? Were any complaints dealt with discreetly/empathetically? If so, how were they resolved? Were your onward needs anticipated (luggage, transportation etc)? Any requests met or adapted to? Was service proactive vs reactive? Were you impressed or disappointed about anything? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, memorable touchpoints)',
        PARAGRAPH4:
          'Did the employee express their gratitude? Was the farewell warm, perhaps using your name or an invitation to return? Did the farewell create a lasting impression? (FAREWELL) What summarises your overall experience? Were you left with a positive/negative memorable experience? Any special or thoughtful moments that impressed you and left a lasting memory? (SUMMARY)',
      },
      PORTER_ARRIVAL: {
        PARAGRAPH1:
          'Were the employees well-groomed and standing alert? What was your first impression? Did the employee welcome you confidently and use the name of the hotel? Were you hended over smoothly to reception, and was your luggage handled efficiently? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Was your name used by the employees? were they friendly and did the welcome feel genuine? Did they make conversation with you? Was the conversation engaging or personalised and how/to what degree? Was any thoughtfulness or care shown, and if so how? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Was the overall process well organised? Following your arrival in the room, did the employee anticipate your needs to make you feel welcome? Were you made to feel at home in the room? e.g. your coat was hung, laundry was offered, the view was highlighted, any specific services offered. Any missed opportunities? Any special moments? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, memorable touchpoints)',
        PARAGRAPH4:
          'Did the employee wish you a pleasant stay or introduce themselves as they left? Perhaps they provided additional tips for your stay, or offered a specific service as they left? How did this make you feel? (FAREWELL/DEPARTURE) How did you feel overall - at home settled into your new surroundings? excited about your stay? In good hands? Looked after? Or was a negative first impression created? (SUMMARY)',
      },
      PORTER_DEPARTURE: {
        PARAGRAPH1:
          'Was the call answered straight away or was there a delay/no answer? Was the luggage request readily dealt with? Was your name used? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the porter engage you in personal conversation? Perhaps they asked you about your stay or plans for the day? Maybe they showed empathy or patience while you were still packing? Did the employee use open body language and was he/she upbeat in manner? Did they try to create a connection with you despite the short interaction, and if yes, how? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Was the process organised? (e.g. collection was quickly arranged, was a luggage ticket issued). Were any requests passed on to demonstrate collaboration? Did the employees take genuine care and responsibility for your luggage, onward transportation or car? How did the employees anticipate your departure needs? Any final touches, such as reminding you to check the safe? How did this make you feel? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Did any of the employees extend an invitation to return, and if so, was it genuine and how did it make you feel? Was the final farewell sincere? Think about your lasting impressions; did the team provide any small/thoughtful gestures, such as a little gift, bottle of water, or snack for the journey? (FAREWELL/DEPARTURE) How did you feel overall as you left for the airport? Did you take away any stories that you will tell others from your experience at the hotel? Did they wave you goodbye? (SUMMARY)',
      },
      GUEST_SERVICES: {
        PARAGRAPH1:
          'Any pre-arrival communication such as emails or calls that created a positive/negative impression ahead of your stay? Were employees well-groomed and were concierge desks tidy and organised? Did you have the impression that the employees were approachable due to their appearance, such as open body language, or regular eye contact? (SET THE SCENE)   ',
        PARAGRAPH2:
          'Throughout the various interactions were the employees friendly? Was your name used overall and in what way? were any of the interactions personalised, and to what degree? Was any empathy or understanding shown? Any special or personalised touches worth mentioning? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Did service feel organised overall e.g. timely responses and deliveries? Did the concierge understand your emotions and needs? Any intuitive touches you could mention, such as offering to send information about a particular restaurant or experience via WhatsApp? Any special requests met or adapted to? Did anything impress you or surprise you? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Did your enquiries result in tailored and insightful suggestions? Were any amenities left in the room, such as a handwritten card from Guest Services with a personalised gift? Anything to note about the presentation of any requested items, perhaps they were artistically or luxuriously presented? (PRODUCT e.g. quality of GS recommendations, GS amenities)',
        PARAGRAPH5:
          'Did the overall experience create any memorable experiences for you? did this enhance your emotional connection to the hotel? Any stories that you will take away and tell others? Any highlights? (SUMMARY)',
      },
      RESTAURANT: {
        PARAGRAPH1:
          'Did you receive a warm welcome? Or perhaps the employees did not notice you or apologise for a delay? Were the employees well-groomed and attentive? Was a choice of tables offered, or a nice table suggested? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the employees take the time to connect with you on a personal level, and if so, how? Was your name known and how was it used? Were the employees friendly or enthusiastic? Did they display pride/passion for food and wine through the recommendations they made? Any thoughtful touches or empathetic moments? Did a chef or manager visit the table? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Did the employees confidently explain the concept or use storytelling about the food, chef or ingredients and if so, how did that make you feel? How were any special/off-menu requests handled, and how did this make you feel? Was service organised? Any thoughtful, surprising or inspiring touches? Did anyone ask if you had enjoyed the meal? Were you impressed or disappointed about anything? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Did the food/dishes/menu evoke any emotions such as nostalgia? Was the concept inspiring or innovative? Was the food artistically presented? Anything worth noting with regards to portion sizes? Any surprising elements? Was the wine nicely chilled and enjoyable, as it was tailored to your preferences? (PRODUCT i.e. food & drinks) How connected did you feel to the surroundings? did the ambiance (lighting, music, décor, etc.) contribute to your overall experience? Was the music appropriate, or too loud or quiet? Did the lighting feel too bright? Was the décor elegant, luxurious, contemporary? Did it feel exclusive? (AMBIANCE)',
        PARAGRAPH5:
          'Was the bill quickly arranged? Did any employees say goodbye or thank you as you left, or did you leave unnoticed? Was an invitation to return was extended? (FAREWELL/DEPARTURE) How did you feel about your dining experience overall despite any positives or negatives? Any highlights that will leave a lasting memory/impression? (SUMMARY)',
      },
      BREAKFAST: {
        PARAGRAPH1:
          'Did you receive a warm welcome? Or perhaps the employees did not notice you or apologise for a delay? Were the employees well-groomed and attentive? Was a confident or friendly escort to the table provided? Was a choice of tables offered or a nice table suggested? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the employees take the time to connect with you on a personal level, and if so, how? Was your name known and how was it used? Were the employees friendly or enthusiastic? Any thoughtful touches or empathetic moments? Did the employees mirror your mood? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Did the employees confidently explain the breakfast concept or perhaps use any storytelling, and if so, how did that make you feel? How were any special/off-menu requests handled, and how did this make you feel? Was service organised and proactive, versus reactive? Any thoughtful touches? Did anyone ask if you had enjoyed your breakfast? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Did the food/dishes/menu evoke any feelings, such as comfort classics or traditional dishes which created a sense of place? Was the food of good quality and nicely presented? Anything worth noting with regards to portion sizes? (PRODUCT i.e. food & drinks) How did the ambiance (lighting, music, décor, etc.) contribute to your overall experience? Was the music appropriate, or too loud or quiet for the time of day? Did the layout feel comfortable or were the tables cramped/next to a noisy kitchen? The décor? (AMBIANCE)',
        PARAGRAPH5:
          'Was the bill quickly arranged? Did any employees say goodbye or thank you as you left, or did you leave unnoticed? Was an invitation to return extended perhaps? (FAREWELL/DEPARTURE) How did you feel about your experience overall despite any positives or negatives? Any highlights that will leave a lasting memory/impression? (SUMMARY)',
      },
      LIGHT_MEALS: {
        PARAGRAPH1:
          'Did you receive a warm welcome? Or perhaps the employees did not notice you or apologise for a delay? Were the employees well-groomed and attentive? Was a confident or friendly escort to the table provided? Was a choice of tables offered or a nice table suggested? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the employee engage you in personal conversation, and if so, to what degree and how did this make you feel? Did they use your name and in which way, did it feel natural and discreet? Were they good, clear communicators? Were the employees able to connect with you straight away? Maybe they used humour? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Were the employees confident and did this result in an organised service? Were employees proactive? If yes, how did this impact your experience? maybe it allowed you to relax or enjoy the view? How were requests handled? Any thoughtful touches? Did anyone ask if you had enjoyed your meal? Was service proactive vs reactive? Were you impressed or disappointed about anything? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Did the food/dishes/menu evoke any feelings, such as comfort classics or traditional dishes which created a sense of place? Was the food of good quality and nicely presented? Anything worth noting with regards to portion sizes? (PRODUCT i.e. food & drinks) How did the ambiance (lighting, music, décor, etc.) contribute to your overall experience? Was the music appropriate, or too loud or quiet for the time of day? Did the layout feel comfortable or were the tables cramped/next to a noisy kitchen/were positioned on a nice terrace with view/heating was appropriate for outside tables? (AMBIANCE)',
        PARAGRAPH5:
          'Was the bill quickly arranged? Did any employees say goodbye or thank you as you left, or did you leave unnoticed? (FAREWELL/DEPARTURE) How did you feel about your experience overall despite any positives or negatives? Any memorable moments or highlights that will leave a lasting impression? (SUMMARY)',
      },
      DRINKS: {
        PARAGRAPH1:
          'Was a genuine welcome extended, or did you enter the bar unnoticed? Were the employees well-groomed and attentive? Was a choice of tables offered or perhaps a nice table suggested? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Was there an opportunity to demonstrate recognition or remember your preferences? How did this make you feel? Did the employee attempt to engage you in conversation and to what degree? Any thoughtful touches or suggestions? Did their personality shine through and how did this impact your experience? (EMPLOYEE INTERACTIONS e.g. name usage, degree of personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Was the service attentive? Were the staff knowledgeable, or did they perhaps show a passion for cocktails or engage in storytelling? Was there generosity demonstrated and how did this make you feel? For example, offering to taste any drinks or providing canapés? Was service proactive vs reactive? Were you impressed or disappointed about anything? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Were the beverages creatively presented? Perhaps they were elegant, quirky or classic, which reflected the bar concept overall? Was there a generous selection of good quality snacks perhaps, which paired well with the drinks? (PRODUCT i.e. food & drinks) Was a unique atmosphere created? Think of live music and décor, for example a cosy fireplace, or scenic views, elegant or sophisticated décor, or comfortable seating that promoted relaxation? (AMBIANCE)',
        PARAGRAPH5:
          'Did anyone come back to check on you, or were you ignored once you finished your drink? Was the bill quickly organised? Perhaps the employee escorted you to the restaurant for dinner or wished you a lovely evening as you left - or maybe you left unnoticed? (FAREWELL) Despite any highs or lows, how did you feel overall? any highlights or memorable touchpoints that left you with a lasting memory? (SUMMARY)',
      },
      IN_ROOM_DINING: {
        PARAGRAPH1:
          'Was the call taken straight away or were you kept on hold? Was the order taking process smooth and did the employee appear friendly or use your name? were they able to answer questions or adapt to any requests? Was there any background noise? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'When the meal arrived was the employee friendly or distant? Was the mindful or respectful of your personal space? How did this make you feel? Did they use your name or engage you in conversation and to what degree? (EMPLOYEE INTERACTIONS e.g. name usage, personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Overall, was the service prompt and efficient? During the experience, how did the employee show care for your needs and how did this make you feel? Was the food well-presented and did it feel like a luxurious dining experience or a rushed delivery? Was any storytelling used while presenting the dishes? Was service proactive vs reactive? Were you impressed or disappointed about anything? (SERVICE i.e. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'What emotions did the food evoke in terms of presentation, flavours, style, temperature, and texture? Were there any special touches or extras such as complimentary canapes or generous bread selection? (PRODUCT i.e. food & drinks) Was the room service beautifully/carefully presented, creating a luxurious in room dining atmosphere, versus a “food delivery”? Did the employee attempt to create a restaurant style experience? (AMBIANCE)',
        PARAGRAPH5:
          'If the food was collected, was this quickly arranged and were you asked if you enjoyed the meal? If yes, did it feel genuine? (FAREWELL) How did you feel overall, despite any highlights or lowlights? (SUMMARY)',
      },
      SPA: {
        PARAGRAPH1:
          'If a reservation was made, was the employee knowledgeable? Did they listen to your needs/concerns and then offer personalised treatment recommendations? When you arrived at the spa, did the employees greet you in a genuine way that made you feel welcome? Were you provided with a welcoming orientation, and/or was your health form dealt with discreetly? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the employees engage you in a personal way, creating an immediate connection, or did they remain distant or detached? Was the interaction personalised and if so how/to what degree? Was your name used and how? Was any care and empathy shown? (EMPLOYEE INTERACTIONS e.g. name usage, personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Throughout the experience, did the employees think of your privacy and comfort? Were your needs/preferences communicated to the therapist? How did this leave you feeling? How did the employees demonstrate attention to detail? What luxurious touches did you experience, if any? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Were there plush linens, robes, and slippers to enhance a sense of indulgence? Was the offering high-end (facials, massages, holistic therapies)? Was the massage expertly tailored to your needs? Were the products of high quality – perhaps they added a touch of aromatherapy to the experience? (PRODUCT e.g. spa treatment & products) Did the décor and ambience enhance your experience and how did this impact how you felt? Was the atmosphere in the treatment room relaxing? Perhaps the lighting was too bright, or music too low/loud. Or perhaps it felt inappropriate for a spa setting? (AMBIANCE)',
        PARAGRAPH5:
          'Were you provided with any post-treatment advice and was this tailored to you as an individual? Was the departure smoothly handled, with either an escort back to reception or an option to relax after your treatment? Were sincere thanks shown? Perhaps you were invited to return, and if so how did that make you feel? (FAREWELL) Summarise how you felt overall, despite any highlights or lowlights - were any memorable moments created? What was your lasting impression? (SUMMARY)',
      },
      TRANSPORT: {
        PARAGRAPH1:
          'Was an employee immediately visible at the arranged time and did they acknowledge you in a warm and genuine manner? How did this make you feel and what first impression did this provide? Did they take charge of your luggage and what impression did this provide? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'If appropriate, did the employee engage about the local area to enhance the experience? Did they ask questions about your journey or where you had travelled from in an attempt to engage on a personal level? How did this leave you feeling? Did they mirror your mood? (EMPLOYEE INTERACTIONS e.g. name usage, personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Was the service professional? Was service seamless and welcomed after a long journey, or did the experience feel disorganised and stressful? Any luxurious or intuitive touches that you appreciated, such as asking which type of music you preferred, or offering a welcome drink, or a cool/hot towel? Did the employee drive carefully, resulting in a safe and comforting experience, or did the experience feel risky or unsafe in any way? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Was the vehicle clean, tidy and luxurious and how did this make you feel? Were any additional products included which have not been mentioned already, such as a tablet with hotel information, a selection of magazines or phone chargers etc? (PRODUCT e.g. vehicle & offered products) was the vehicle comfortable and fresh? Or perhaps it smelt of smoke or felt stuffy? (AMBIANCE)',
        PARAGRAPH5:
          'As you reached the hotel, did the employee communicate your ETA, and did this result in an organised arrival? Was a genuine goodbye extended? Were you introduced to the hotel employees? (FAREWELL) How did you feel overall, despite any highlights or lowlights? Did the experience result in feeling refreshed, uplifted or welcomed, or perhaps you felt stressed which did not provide a positive start to your trip? (SUMMARY)',
      },
      GOLF: {
        PARAGRAPH1:
          'Was the arrival experience seamless and smooth? Was an employee present and did he welcome you in a friendly way? (ARRIVAL/SET THE SCENE)',
        PARAGRAPH2:
          'Did the interactions boost your self-esteem and confidence? Did the personal interactions with the staff (caddies or instructors) create positive connections? Were the interactions perosnalised and to what degree? (EMPLOYEE INTERACTIONS e.g. name usage, personalisation, empathy, clear communication, friendliness)',
        PARAGRAPH3:
          'Was the service attentive, for example from the caddy and staff? Did they show understanding and consideration for your comfort and needs? How did this make you feel? Was there access to expert golf pros or instructors if required? (SERVICE e.g. seamless, intuitive, adapting to needs, meeting requests, confidence, memorable touchpoints)',
        PARAGRAPH4:
          'Was high-end equipment availability? Think of top-tier clubs, golf carts, and accessories. Were these well maintained? Were the other facilities well maintained and luxurious, for example, the reception, locker rooms and relaxation areas? (PRODUCT i.e. golf equipment & facilities) How did the atmosphere and surroundings help you connect with the experience? Was there any feeling of exclusivity? Was the course thoughtfully designed with scenic views, challenging holes, and was it kept in immaculate condition? (AMBIANCE)',
        PARAGRAPH5:
          'Did any employees say goodbye or thank you as you left, or did you leave unnoticed? (FAREWELL/DEPARTURE) How did you feel about your experience overall despite any positives or negatives? Motivated, inspired? Any memorable moments or highlights that will leave a lasting impression? (SUMMARY)',
      },
      POSITIVE_ASPECTS_OF_THE_EXPERIENCE: {
        PARAGRAPH1:
          'Cover both ACTION + FEELING (not necessarily in that order) without being too formal, formulaic or scripted e.g.',
        PARAGRAPH2:
          'The arrival experience, which included the welcome ritual and a friendly greeting in the local language, created a sense of place and exciting start to the stay.',
      },
      NEGATIVE_ASPECTS_OF_THE_EXPERIENCE: {
        PARAGRAPH1:
          'Cover both ACTION + FEELING (not necessarily in that order) without being too formal, formulaic or scripted e.g.',
        PARAGRAPH2:
          'I enjoyed the meal and atmosphere, but the overall experience was let down by the service; the repeated enquiries about my well-being, though well-meaning, became frustrating.',
      },
      RECOMMENDATIONS_TO_ENHANCE_CUSTOMER_EXPERIENCE: {
        PARAGRAPH1:
          'What, Why, How? Explain the overarching goal of what they should do, why they should do it and specific examples/instructions on how to do it. Does not need to be written in this order so that it sounds formulaic and repetitive, but needs to cover these three elements e.g.',
        PARAGRAPH2:
          'Implement stricter quality control measures, (what) such as standardised food preparation checklists, along with conducting weekly kitchen audits to review hygiene practices, (how) to help prevent similar incidents. (why)',
        PARAGRAPH3:
          'Remind employees about the importance of using the guest’s name (what) to make the guest feel unique and more than just a “room number” (why). For example, the guest’s name could be used on seating the guest once their room number is confirmed, or when checking their satisfaction with the meal. (how)',
      },
    },
    ICON_INFO: {
      ICON_INFORMATION: {
        HEADING: 'Icons Information',
        ICONS: 'Icons',
        DESCRIPTION: 'Description',
        BUTTON_TITLE: 'Icon Legend',
      },
      PLANE: {
        GREY: 'Flight cost is included in assessment fee',
        BLACK: 'Flight is billable back to client external to assessment fee',
      },
      PEOPLE: {
        LIGHT_GREY: 'No partner allowed, not specified by client',
        GREY: 'Partner is optional',
        BLACK: 'Partner required',
      },
      GROUP_PEOPLE: {
        GREY: 'Family not specified by client',
        BLACK: 'Family optional/required check notes',
      },
      NOTES: {
        GREY: 'No notes available',
        OUTLINE: 'Contract notes available',
        BLACK: 'Consultant or Internal notes available',
      },
      ALERT: {
        GREY: 'No conflicts in the scheduling',
        BLACK: 'Potential conflict in schedule please click on icon to see the details',
        RED: 'Conflicts in the schedule please click on icon to see the details',
      },
      ASSESSMENT: {
        NEW_INSPECTION: 'New Inspection',
        REINSPECTION: 'Re Inspection',
        FEEDBACK_PLUS: 'Feedback Plus',
        TRAINING: 'Training',
      },
      CONSULTANT_AIR_FARE: {
        FILLED: 'Consultant flight is billable back to client external to assessment fee.',
        BLANK: 'Consultant flight cost is included in assessment fee',
      },
      PARTNER_AIR_FARE: {
        FILLED: 'Partner flight is billable back to client external to assessment fee',
        BLANK: 'Partner flight should not be billed back to customer',
      },
    },
    SCHEDULING: {
      PRIORITY_STATUS: {
        MUST_THIS_MONTH: 'Must be scheduled this month',
        TWO_MONTHS_LEFT: '2 months left to schedule',
        MORE_THAN_TWO_MONTHS: 'More than 2 months to schedule',
      },
      ADDITIONAL_SCHEDULING: {
        HEADING: 'Additional Scheduling',
      },
      STAFF_SCHEDULING: {
        HEADING: 'Staff Scheduling',
        CONSULTANT_FILTER: {
          TRAINER: 'Trainer',
        },
        CONFIRM_POPUP: {
          UNALLOCATE:
            'This assessment has been allocated to {username}’s roster. Are you sure you want to un-allocate this assessment?',
          REALLOCATE:
            'This assessment has already been allocated to {username}’s roster. Are you sure you want to re-allocate this assessment?',
          PUBLISH_STATUS:
            'This month’s schedule has already been published. You’ll have to re-publish it after this action. Do you want to proceed?',
          ALREADY_PUBLISH: 'The current schedule has already been published. How do you want to proceed?',
        },
      },
      HOTEL_SCHEDULING: {
        HEADING: 'Hotel Scheduling',
      },
    },
    USER: {
      MESSAGE: {
        ERROR_REPRESENT: 'Error representing the selected user.',
      },
    },
    HOTEL: {
      DASHBOARD: {
        COMPETING_HOTELS: 'Competing Hotels',
        COMPETING_HOTELS_IN: 'Competing Hotels in',
      },
      TRENDS: {
        STANDARD: {
          LEGEND_HEADING: {
            TOP_5_MISSED: 'Top 5 Missed Standards',
            TOP_5_MET: 'Top 5 Met Standards',
            CUSTOM: '5 Custom Standards',
          },
          SCORE_FILTER: {
            PERFORMANCE_CLASSIFICATION: 'Select Performance Classification',
            CATEGORY: 'Select Department',
          },
          REPORT_DELAY_WARNING:
            'The report is taking longer than usual to generate. You can keep waiting or try again later.',
          FILTER_TYPE: {
            TOP_5_MISSED: 'Top 5 Missed',
            TOP_5_MET: 'Top 5 Met',
            MY_VIEW: 'My View',
          },
          MANAGE_STANDARDS: 'Manage Standards',
          MANAGE_CUSTOM_STANDRDS: 'Manage Custom Standards',
          SELECT_ALL_STANDARDS: 'Please Select all standards',
          CHOOSE_STANDARD: 'Choose standard',
        },
      },
      ASSESSMENT: {
        SUMMARY: {
          TITLE: 'Hotel Assessment Summary',
          ERROR: {
            NO_DEFAULT_TEMPLATE: 'No default template assigned to this hotel.',
            NO_HOTEL_SELECTED: 'No hotel selected.',
          },
        },
      },
      MESSAGE: {
        ERROR_REMOVE_BRAND: 'At least one brand is required.',
        CHECK_DETAILS: 'Please check the details',
        ADD_HOTEL_NAME: 'Please add a Name for this Hotel',
        ADD_DISPLAY_NAME: 'Please add a Display Name for this Hotel',
        HOTEL_SIZE: "Please select the Hotel's Size",
        HOTEL_TYPE: "Please select the Hotel's Type",
        ADD_BRANDS: 'Please add a Brand for this Hotel',
        VALID_EMAIL: 'Please add a valid email',
        VALID_PHONE_NUMBER: 'Please add a valid Phone Number',
        COMPETITIVE_SET_LOCATION: 'Please select a location for the Default Competitive Set',
      },
    },
    CONTRACT: {
      ASSESSMENT: {
        SHOW_DETAILS: 'Show Details',
        SAVE_INFO_MESSAGE: 'Hotels must be selected in order to save changes made to them',
        NO_HOTEL_SELECTED: 'Please select hotels.',
        MAX_AVG_RATE_MESSAGE: 'Rate should not be greater than 2,147,483,647.',
      },
    },
    LQA_ACADEMY_NEWS: {
      HEADING_DESCRIPTION: 'The First-of-its-Kind Immersive Luxury Hospitality Training Experience',
      PARA_HEADING: 'Transform your rising hospitality stars into exceptional guest experience leaders.',
      LEARN_MORE: 'Discover ACADEMY by LQA',
    },
    LQA_SIRIUS_AWARDS: {
      HEADING_INTRO: 'Introducing the',
      HEADING_TITLE: 'LQA Sirius Awards',
      DESCRIPTION_LINE1: 'The only awards exclusively honouring',
      DESCRIPTION_LINE2: 'frontline excellence in luxury hospitality.',
      DESCRIPTION_LINE3: '50 exceptional winners will be selected from',
      DESCRIPTION_LINE4: "LQA's 2025 Star Employees.",
      DISCOVER_MORE: 'Discover More',
    },
    ROSTER: {
      TASKS: {
        OFFICE_DAY: 'Office Day',
        DAY_OFF: 'Day Off',
        PUBLIC_HOLIDAY: 'Public Holiday',
        TRAVEL_DAY: 'Travel Day',
        CHECKOUT_AND_FLY_HOME: 'Check out and fly',
        ARRIVE_HOME: 'Arrive Home',
        TRAINING_DAY: 'Training Day',
        WORK_FROM_HOME: 'Work From Home',
        WORK_FROM_HOME_OFFICE_DAY: 'Work From Home - Office Day',
        UPFRONT_PREP: 'Upfront Prep',
        PLANNING_DAY: 'Planning Day',
        IN_LIEU: 'In Lieu',
        SICK_DAY: 'Sick Day',
        WEEKEND: 'Weekend',
        REST_NIGHT: 'Rest Night',
        OTHER: 'Other',
      },
      AUDITS: {
        COLUMNS: {
          HOTEL: 'Hotel',
          TYPE: 'Type',
          NIGHTS: 'Nights',
          PARTNER: 'Partner',
          DETAILS: 'Details',
          TEMPLATE: 'Template',
          LOCATION: 'Location',
          CONSULTANT_NOTES: 'Consultant Notes',
          CONTRACT_NOTES: 'Contract Notes',
          BLOCKOUT_DATES: 'Blockout Dates',
        },
      },
      FLIGHT_PLANNER: {
        SELECT_AUDIT_ERROR: 'Please select at least one itinerary item with an audit.',
        INSPECTIONS: 'Inspections',
        SOS_HEADING: 'Add International SOS Flight Details',
        DISPLAY_HEADING: 'International SOS Flight Details',
        ERROR_MESSAGE: 'Please fill all flight details',
        MISSING_FLIGHT_DETAILS: 'Please fill the missing flight details: {{fields}}',
        SAVE_ERROR_MESSAGE_INFORMATION: 'Fill all information.',
        AFTER_SUBMISSION_ERROR_MESSAGE: 'After submission flight planner cannot be updated.',
        SELECT_ASSESSMENT_ERROR: 'Please select at least 1 assessment',
        FILL_ITINERARY_ERROR: 'Please fill itinerary',
        AIRPORT_CODE_VALIDATION: 'Please enter a valid 3-letter IATA Airport Code',
        ORIGIN_AIRPORT_CODE_VALIDATION: 'Please enter a valid 3-letter IATA Airport Code for the origin',
        DESTINATION_AIRPORT_CODE_VALIDATION: 'Please enter a valid 3-letter IATA Airport Code for the destination',
        CONTINUE_NEW_FLIGHT_PLANNER_VALIDATION: 'Select an audit and valid date range',
        BLOCKOUT_NON_TRAINING_ROSTER_ERROR:
          'This hotel has blocked out the day you are scheduling for the audit. Please select a different day or contact the Admin team.',
        TRAINING_BLOCKOUT_WARNING_TITLE: 'Block Out Date Warning',
        TRAINING_BLOCKOUT_WARNING_DESCRIPTION:
          'You have training assessments scheduled for Block Out Dates. Are you sure you want to continue?',
        COLUMNS: {
          ORIGIN: 'Origin',
          ORIGIN_DATE: 'Origin Date',
          DESTINATION: 'Destination',
          DESTINATION_DATE: 'Destination Date',
          AIRLINE_CODE: 'Airline Code',
          FLIGHT_NUMBER: 'Flight Number',
        },
      },
    },
    FLIGHT_PLANNER: {
      EDIT_FLIGHT_PLANNER: {
        TITLE: 'Edit Flight Planner',
      },
    },
    HOLIDAY_REQUEST: {
      ENTITLEMENT_TITLE: 'My Entitlement',
      NUMBER_OF_WORKING_DAYS: 'Number of working days',
      COLUMN: {
        YEAR: 'Year',
        ENTITLEMENT: 'Entitlement',
        TOTAL_DAYS_REMAINING: 'Total days remaining',
        DAYS_REMAINING_AFTER_APPLICATION: 'Days Remaining After Application',
        DAYS_APPLIED: 'Days Applied in this Application',
      },
    },
    TABLE: {
      FILTER_BAR: {
        FILTERED_BY: 'Filtered by:',
      },
      TOOL_BAR: {
        FILTERS: 'Filters',
        FILTER: 'Filter',
      },
      PAGINATION: {
        ITEMS_PER_PAGE: 'Items per page:',
        SHOWING: 'Showing',
      },
      CHECKBOX_DROPDOWN: {
        SELECT_PAGE_ROWS: 'Select page rows',
        SELECT_ALL_ROWS: 'Select all rows',
      },
    },
    GLOBAL: {
      TITLE: 'Global LQA Statistics',
      DESCRIPTION: 'Use the filters below to see the average scores of all LQA customers for the selected filter',
      FILTERS: {
        PLACEHOLDER: 'Please select...',
        SELECT_REGION: 'Select Region',
        SELECT_SUB_REGION: 'Select Sub-Region',
        SELECT_COUNTRY: 'Select Country',
        SELECT_LOCATION: 'Select Location',
        SECTOR: 'Sector',
      },
      LEGEND: {
        DESCRIPTION: '.Your score compared to the scores achieved within your competitive set.',
        SUCCESS: 'Above avg. range',
        WARNING: 'Within avg. range (2pts)',
        DANGER: 'Below avg. range',
      },
    },
    BLOCKOUT_DATES: {
      TITLE: 'Block Out Dates',
      SUBMIT_BLOCK_OUT_PERIOD: 'Submit block out period',
      GUIDELINES_AND_RESTRICTIONS: 'Guidelines and restrictions for block out dates',
      MODAL: {
        KEY_GUIDELINES: 'Key Guidelines',
        INTRO_TEXT:
          'To ensure fairness and consistency, please adhere to the following when submitting block out dates:',
        MAX_60_DAYS_PER_YEAR: 'Maximum of 60 block out days per calendar year',
        MAX_15_DAYS_PER_MONTH: 'Maximum of 15 block out days in any given month',
        FLEXIBILITY_NOTE:
          'These limits are flexible in specific situations (e.g., extended closures or seasonal downtime), but LQA reviews all submissions and may request clarification or revisions if needed.',
        IMPORTANT_RESTRICTIONS: 'Important Restrictions',
        NO_DATES_WITHIN_60_DAYS: 'No block out dates may be entered within the next 60 days',
        RULE_EXPLANATION:
          'This rule is built into the system. Assessments may already be scheduled, and short-notice changes could result in logistical or financial impacts.',
        EMERGENCY_CONTACT:
          'If you have an emergency and need to block dates within the 60-day window, please contact our team directly at:',
      },
      ERROR_MESSAGE: {
        DATES_WITHIN_60_DAYS: 'Please note that block out dates cannot be submitted less than 60 days in advance.',
      },
    },
    HOTEL_DASHBOARD: {
      TITLE: 'Hotel Dashboard',
      NO_HOTEL_SELECTED: 'No hotel selected',
      NO_BRAND_SELECTED: 'No brand selected',
      NO_ASSESSMENT_AVAILABLE: 'No Assessment Available',
    },
    BOOSTERS: {
      BOOSTERS_CONTENT_MANAGER: 'Boosters Content Manager',
      TOPICS: 'Topics',
      BOOSTER_TOPICS: 'Booster Topics',
      ADD_TOPIC: 'Add Topic',
      VIEW_ALL_BOOSTERS: 'View all Boosters',
      CONTENT_CHANGES_ALERT:
        'Important: The Boosters progress and topic order for each user is not affected by changes made in the content manager, unless users have cycled through the entire set of topics. However, any changes made to the content of the boosters (Title, Headline, Objective and Steps) will always stay updated as in the content manager.',
      PAGE_TITLE_TOPICS: 'Boosters Content Manager - Topics',
      ADD_TOPIC_PAGE_TITLE: 'Add Topic - Boosters Content Manager',
      EDIT_TOPIC: 'Edit Topic',
      EDIT_TOPIC_PAGE_TITLE: 'Edit Topic - Boosters Content Manager',
      TOPIC_TITLE: 'Topic Title',
      TOPIC_WEEK_ORDER: 'Topic Week Order',
      TOPIC_WEEK_ORDER_TOOLTIP: 'The order must be unique across all topics (not null, >= 1).',
      ANOTHER_TOPIC_DISPLAY_ORDER: 'Another topic already has this display order. The order must be unique.',
      BOOSTERS_CONTENT: 'Boosters Content',
      ADD_NEW_BOOSTER: 'Add new Booster',
      VIEW_TOPICS: 'View Topics',
      ALL_TOPICS: 'All Topics',
      ALL_DEPARTMENTS: 'All departments',
      BOOSTER_TITLE: 'Booster Title',
      HEADLINE: 'Headline',
      TOPIC: 'Topic',
      SELECT_TOPIC: 'Select topic',
      DAY: 'Day',
      DAY_TOOLTIP: 'The order must be unique within the same topic (not null, >= 1).',
      STEP_CONTENT: 'Step Content',
      STEP_MESSAGE: 'Step Message',
      ADD_STEP: 'Add step',
      OBJECTIVE: 'Objective',
      STEPS: 'Steps',
      DEPARTMENTS: 'Departments',
      EDIT_BOOSTER: 'Edit Booster',
      ADD_BOOSTER: 'Add Booster',
      EDIT_BOOSTER_PAGE_TITLE: 'Edit Booster - Boosters Content Manager',
      ADD_BOOSTER_PAGE_TITLE: 'Add Booster - Boosters Content Manager',
      SELECT_AT_LEAST_ONE_DEPARTMENT: 'Select at least one department',
      ANOTHER_BOOSTER_DAY: 'Another booster in this topic already has this day. The day must be unique.',
      BOOSTERS_BUTTON: 'Boosters',
    },
    SUPPORT_VIDEOS: {
      TITLE: 'Support Videos',
      CONTACT_US_AND_FAQS: 'Contact us and FAQs',
    },
    BRAND_BENCHMARKING: {
      COMPARISON_DESCRIPTION: 'Data shows a comparison of {brand} to {amount} competing brands',
    },
  },
};
